/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Createyourfirsteventtostartengagingwithcustomers8Inputs */

const en_createyourfirsteventtostartengagingwithcustomers8 = /** @type {(inputs: Createyourfirsteventtostartengagingwithcustomers8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your first event to start engaging with customers`)
};

const de_createyourfirsteventtostartengagingwithcustomers8 = /** @type {(inputs: Createyourfirsteventtostartengagingwithcustomers8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstell dein erstes Event und erreich neue Gäste.`)
};

/**
* | output |
* | --- |
* | "Create your first event to start engaging with customers" |
*
* @param {Createyourfirsteventtostartengagingwithcustomers8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const createyourfirsteventtostartengagingwithcustomers8 = /** @type {((inputs?: Createyourfirsteventtostartengagingwithcustomers8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Createyourfirsteventtostartengagingwithcustomers8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_createyourfirsteventtostartengagingwithcustomers8(inputs)
	return de_createyourfirsteventtostartengagingwithcustomers8(inputs)
});
export { createyourfirsteventtostartengagingwithcustomers8 as "createYourFirstEventToStartEngagingWithCustomers" }